export default (sections, sectionId) => {
	return [...sections.filter((item) => item.id !== sectionId)];
};
